var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"cursor":"pointer","color":"blue"},on:{"click":function($event){return _vm.view(_vm.row.ResumePath )}}},[_vm._v(" View ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }